/**
 * Link component wrapper.
 * Provides a consistent Link component using React Router.
 * Based on Vuexy Link component, adapted for React Router.
 */

// React Imports
import { forwardRef } from 'react';
import type { ComponentProps, ForwardedRef, MouseEvent } from 'react';

// React Router Imports
import { Link as RouterLink } from 'react-router-dom';

/**
 * Link component props
 */
type Props = Omit<ComponentProps<typeof RouterLink>, 'to' | 'onClick'> & {
  href?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Link component.
 * Wrapper around React Router Link with consistent API.
 * @param props - Link props
 * @param ref - Forwarded ref
 */
const Link = (props: Props, ref: ForwardedRef<HTMLAnchorElement>) => {
  // Props
  const { href, onClick, ...rest } = props;

  return (
    <RouterLink
      ref={ref}
      {...rest}
      to={href || '/'}
      onClick={onClick ? (e) => onClick(e) : !href ? (e) => e.preventDefault() : undefined}
    />
  );
};

export default forwardRef(Link);
